var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "opacity-fade" }, on: { "after-enter": _vm.afterEnter } },
    [
      _c(
        "div",
        {
          staticClass: "c-view",
          style: {
            "background-color": _vm.backgroundColor,
            padding: _vm.padding + " 0",
            "z-index": _vm.zIndex,
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "crm-create-card-container",
              style: { width: _vm.width },
              attrs: { "body-style": _vm.bodyStyle },
            },
            [_vm._t("header"), _vm._v(" "), _vm._t("default")],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }